import { SelectedFieldProps } from '../select/types';
import FilterTag from '../tags/filter';

import styles from './autocomplete-multiple.module.css';

export default function SelectedValue({
  selectValues,
  list,
  removeItem,
  withValuesScroll,
  withSuffix,
}: SelectedFieldProps): React.JSX.Element {
  const selectedOptions = selectValues.map((item) => (
    <FilterTag
      key={item}
      type="default"
      title={`${
        list.find((listItem) => listItem.value.toString() === item.toString())
          ?.name as string
      } ${
        withSuffix
          ? `(${list.find(
              (listItem) => listItem.value.toString() === item.toString(),
            )?.suffix})`
          : ''
      }`}
      onClick={() => removeItem && removeItem(item)}
    />
  ));

  return (
    <div
      className={`${styles.selectedRow} ${
        withValuesScroll ? styles.withValuesScroll : ''
      }`}
    >
      {selectedOptions}
    </div>
  );
}
